export enum ClinicConfig {
  sex = "sex",
  useRegistrationPurpose = "useRegistrationPurpose",
  useRepeat = "useRepeat",
}
